import React, { useEffect } from 'react'
import fetchIntercept from 'fetch-intercept'
import { Box } from '@maui/elements'
import { Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import { addNotification } from '../store/notifications'
import routes from '../routes'

const action = addNotification(
  <>
    <Box as="p" mt={0} mb={1}>
      You have hit a limit on the number of requests you can make.
      Please try back again at a later time or upgrade to a higher service level.
    </Box>
    <Box as="p" m={0}>
      <Link to={routes.upgrade()}>
        View upgrade options
      </Link>
    </Box>
  </>,
  {
    id: '429', // note this notification has a static id, so it will only ever appear once
    source: 'Error 429',
    type: 'error',
  }
)

export default function useFetch429Interceptor() {
  const dispatch = useDispatch()

  useEffect(() => {
    return fetchIntercept.register({
      response: res => {
        if (res.status === 429) {
          dispatch(action)
        }
        return res
      }
    })
  }, [dispatch])
}
